<template>
    <div>
        <ul class="flex flex-wrap my-3">
            <li class="text-darkGrayishBlue pr-2">
                <router-link
                    tag="button"
                    :to="homePageRoute"
                    class="focus:outline-none focus:text-darkGrayishBlue font-bold"
                >
                    {{ $t('site.main') }} &gt;
                </router-link>
            </li>
            <li
                v-for="(l, li) in links"
                :key="li"
                class="focus:outline-none focus:text-darkGrayishBlue font-bold"
                :class="{
                    'text-secondary': li === links.length - 1,
                    'text-darkGrayishBlue pr-2': li !== links.length - 1,
                    'cursor-pointer': li !== links.length - 1
                }"
                @click="go(l)"
            >
                <span>
                    {{ l.msg ? $t(l.msg) : l.text }}
                </span>
                <span v-if="li !== links.length - 1">&gt;</span>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        links: { type: Array, default: () => [] }
    },
    methods: {
        go(l) {
            if (l.route) {
                this.$router.push(l.route);
            }
        }
    },
    computed: {
        previewCmpyToken() {
            return this.$store.getters.previewCmpyToken;
        },
        homePageRoute() {
            return this.$store.getters.homePageRoute;
        }
    }
};
</script>
